import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import type { ChangeFilterEvent } from 'components/Table/components/SimpleFilter/types/ChangeFilterEvent';
import { updateSimpleFilterFields } from 'components/Table/helpers/updateSimpleFilterFields';

export type ChangeFilterCommand = ChangeFilterEvent;

export const changeFilter: ApiTableCommandFactory<ChangeFilterCommand> =
  (cmdContext) => async (command) => {
    const { ruleContext } = cmdContext.getState();
    cmdContext.updateState((draft) => {
      draft.simpleFilterFields = updateSimpleFilterFields(
        draft.simpleFilterFields,
        command,
        ruleContext,
      );
    });
  };
